import { EVENTS_RECIEVED, EVENTS_SAVED, EVENTS_DELETED, EVENTS_UNLOADED } from './types'

export default function events(state = [], action = {}){
  switch (action.type) {
    case EVENTS_RECIEVED:
      return action.data
    case EVENTS_UNLOADED:
      return []
    case EVENTS_SAVED:
    let isEdit = false
    const _state = state.map( v => {
      if(v.id === action.data.id){
        isEdit = true
        return action.data
      }else{
        return v
      }
    })
    if(!isEdit){
      return [action.data, ...state]
    }else{
      return _state
    }
    case EVENTS_DELETED:
      return state.filter( v => v.id !== action.data.id )
    default:
      return state
  }
}
